import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'map-modal',
  standalone: false,
  templateUrl: './map-modal.component.html',
  styleUrl: './map-modal.component.scss',
})
export class MapModalComponent implements OnInit {
  lat: number;
  lng: number;
  mapUrl: SafeResourceUrl;

  constructor(
    private _activeModal: NgbActiveModal,
    private _sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    const url = `https://www.google.com/maps?q=${this.lat},${this.lng}&output=embed`;
    this.mapUrl = this._sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  closeModal() {
    this._activeModal.close();
  }
}
